"use client";

import { useUser } from "@/services/contexts/UserContext";
import BlockedPopup from "@/components/atoms/Blocked";

export default function BlockedHandler() {
  const { user } = useUser();

  if (!user?.isBlocked) return null;

  return <BlockedPopup isVisible={true} />;
}
